import {
  analyticsReduxRegistry,
  DATA_LAYER_SCOPES
} from "seneca-common/features/analytics";

import { getUserSchoolId, getUserSchoolName, userHasSchool } from "../state";

export const getSchoolName = (state: any) =>
  userHasSchool(state) ? getUserSchoolName(state) : null;
const getSchoolId = (state: any) =>
  userHasSchool(state) ? getUserSchoolId(state) : null;

analyticsReduxRegistry.registerGlobalSelectorsToDataLayerScope(
  DATA_LAYER_SCOPES.SCHOOL,
  {
    name: getSchoolName,
    schoolId: getSchoolId
  }
);

analyticsReduxRegistry.registerUserPropertiesSelectorsToDataLayerScope({
  name: getSchoolName,
  schoolId: getSchoolId
});
